<template>
	<div class="is-pulled-left">
		<a rel="noreferrer" href="#" class="has-text-primary has-text-weight-bold" @click.prevent="controlModal=true">مشاركة</a>
		
		<div class="modal" :class="{ 'is-active': controlModal}">
			<div class="modal-background is-white"></div>
			<div class="card modal-content">
				<div class="has-text-centered overflow-hidden">
					<div class="has-background-warning has-text-white has-text-weight-bold p5">
						<p class="has-text-centered is-size-6">
							مشاركة 
						</p>
					</div>
					<div class="p30">
						<social-sharing :url="currentUrl"
						:title="productInfo.title"
						:description="description"
						:hashtags="productInfo.location+',Tam,تم  , معارض'"
						inline-template>
						<div>
							<network network="facebook">
								<figure class="is-inline-block card image is-64x64 is-rounded has-background-primary share-icon radius-full">
									<i class="fab fa-facebook-f has-text-white "></i>
								</figure>
							</network>
							<network network="googleplus">
								<figure class="is-inline-block card image is-64x64 is-rounded has-background-primary share-icon radius-full">
									<i class="fab fa-google has-text-white"></i>
								</figure>
							</network>
							<network network="twitter">
								<figure class="is-inline-block card image is-64x64 is-rounded has-background-primary share-icon radius-full">
									<i class="fab fa-twitter has-text-white"></i>
								</figure>
							</network>
							<network network="telegram">
								<figure class="is-inline-block card image is-64x64 is-rounded has-background-primary share-icon radius-full">
									<i class="fab fa-telegram-plane has-text-white"></i>
								</figure>
							</network>
							 
							<network network="whatsapp">
								<figure class="is-inline-block card image is-64x64 is-rounded has-background-primary share-icon radius-full">
									<i class="fab fa-whatsapp has-text-white"></i>
								</figure>
							</network>
						</div>
					</social-sharing>					
				</div>
			</div>
		</div>
		<button class="modal-close is-large has-background-warning" aria-label="close" @click.prevent="controlModal=false"></button>
	</div>
</div>
</template>
<script>
	import trans from "./translation/user.json";
	import SocialSharing from 'vue-social-sharing';
	export default {
		name: "SharePage",
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			productInfo:{
				required: true
			}
		}, 
		components:{
			SocialSharing
		}, 
		locales: trans,
		data: () => ({
			controlModal:false,
			selectedService:null,
			description:null,
			currentUrl:null
			
		}),
		mounted() {
			this.$translate.setLang(this.sitelocale);
			this.currentUrl = window.location.href;
			this.description = this.productInfo.description.replace(/<[^>]*>/g, "").split(' ').slice(0,10).join(" ");

			
		},
		created() {		
		},
		methods: {
			
			
		},

	};
</script>